'use strict';

var config, cacheBuster;

function asset (path) {
  var map = ['a', 'b', 'c'];
  var base = config['ImagesUrl'];
  var key = path.length % 3;

  switch (config['Environment']) {
    case 'Staging':
      base = '//dev-' + map[key] + '.' + base;
      break;
    case 'Production':
      base = '//' + map[key] + '.' + base;
      break;
  }
  return base + path + cacheBuster;
}

module.exports = function cdnFactory (configObj) {
  config = configObj;
  cacheBuster = '?cb=' + (new Date()).getTime();
  return { asset: asset };
};



// WEBPACK FOOTER //
// ./gulp/cdn-preprocessor.js